// extracted by mini-css-extract-plugin
export default {"footerWidgetText":"footerWidgetText--rg4J1"};